/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'msg': {
    width: 16,
    height: 16,
    viewBox: '0 0 20.25 13.43',
    data: '<g data-name="图层 2"><path pid="0" d="M17.56 0H2.69A2.69 2.69 0 000 2.69v8a2.69 2.69 0 002.69 2.69h14.87a2.69 2.69 0 002.69-2.69v-8A2.69 2.69 0 0017.56 0zm1.69 10.74a1.69 1.69 0 01-1.69 1.69H2.69A1.69 1.69 0 011 10.74v-8a1.68 1.68 0 01.52-1.21l8.61 5.23 8.76-5.06a1.67 1.67 0 01.37 1z" _fill="#9fa0a0" data-name="图层 1"/></g>'
  }
})
